document.addEventListener('DOMContentLoaded', function () {
    const variantInput = document.querySelector('input[name="id"]');
    const variantsJson = document.getElementById('product-variants-json');
    let skus;

    if (variantsJson) {
      const variants = JSON.parse(variantsJson.textContent);
      skus = variants.map(v => v.sku ? v.sku.trim().toLowerCase() : []);
    }

    function updateColorImage() {
      const mediaElements = document.querySelectorAll('[data-media-alt]');
      const sku_element = document.querySelector('.product__sku');
      const sku_info = Array.from(sku_element.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent.trim())
      .join(' ')
      .trim().toLowerCase();
      const isSkuMatch = skus.includes(sku_info);

      /*
      console.log("SKU Info:", sku_info);
      console.log("SKUs:", skus);
      console.log("Is SKU Match:", isSkuMatch);
      */
      
      if (mediaElements && mediaElements.length > 0) {

        const matchExists = Array.from(mediaElements).some(el => {
          const altColor = el.getAttribute('data-media-alt').trim().toLowerCase();
          return altColor.includes(sku_info);
        });
        
        if (isSkuMatch && matchExists) {
          mediaElements.forEach((el) => {        
            const altColor = el.getAttribute('data-media-alt').trim().toLowerCase();
            const isMatch = altColor.includes(sku_info);        
              if (isMatch) {
                el.classList.remove('hidden');
              }else {
                el.classList.add('hidden');
              }
          });
          
        }
        else {
            if (isSkuMatch) {
            mediaElements.forEach((el) => {       
              const altColor = el.getAttribute('data-media-alt').trim().toLowerCase(); 
              const getPrdTitleEle = document.querySelector('.product__title');
              const getPrdTitle = getPrdTitleEle.getAttribute('data-product-title').toLowerCase();
              console.log(altColor);
              if (altColor.includes(getPrdTitle)) {     
              el.classList.remove('hidden');   
              }else {
                el.classList.add('hidden'); 
              } 
            });
          }
        }
      }
    }

    updateColorImage();

    const observer = new MutationObserver((mutationsList) => {
      // console.log("Mutation observed:", mutationsList);
      updateColorImage();
    });

    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  });
  